import * as React from "react";
import {cx} from "emotion";

import "./step-2.scss";

import {bindInput}       from "@Common/react/bind-input";
import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Form2}           from "@Common/react/cs-form-2/form2";
import {minLength}       from "@Common/react/cs-form-2/validators/min-length";
import {required}        from "@Common/react/cs-form-2/validators/required";
import {UseState}        from "@Common/react/use-state";
import {getCountryName2} from "@Common/ui-components/country-codes";
import {Select}          from "@Common/ui-components/heavy/common/design2/select/select";

const usStates = require("@Common/ui-components/heavy/common/us-states.json");
const canadaProvinces = require("@Common/ui-components/heavy/common/canada-provinces.json");

export const Step2 = ({data = undefined, next: rootNext}) => cs(

    ["data", (_, next) => UseState({initValue: data, next})],
    ["form", ({data}, next) => Form2({
        fields: formFields,
        data,
        next,
    })],
    ["submitError", (_, next) => UseState({next})],
    ({form, data, submitError}) => rootNext({
        action: {
            disabled: !form.valid,
            clickedWhenDisabled: form.submit,
            onSubmitError: (e) => submitError.onChange(e),
            onClick: ({submit}) => form.submit({onSubmit: submit}),
        },
        modCard: (_) => ({
            ..._,
            ...data.value,
        }),
        render: () => {
            const renderField = ({label, path, renderControl}) => {
                const field = form.field(path);
                return (
                    <div className={cx("form-group", {required: field.isRequired(), hasError: field.error})}>
                        <div className="control-label" xd-qa-type="label" xd-qa-name={label}>
                            {label}
                        </div>
                        {renderControl(field)}
                    </div>
                );
            };
            const inputField = ({label, path, inputProps=undefined}) => renderField({
                label,
                path,
                renderControl: (field) => (
                    <input xd-qa-type="text_field" xd-qa-name={label} {...{
                        ...inputProps,
                        ...bindInput(field.state),
                    }}/>
                )
            });

            const selectField = ({label, path, getControl, xdQaName}) => renderField({
                label,
                path,
                renderControl: (field) => (
                    Select({
                        ...getControl(field),
                        xdQaName,
                        style: {
                            color: field.error ? "danger" : null,
                        },
                    })
                )
            });
            return (
                <div className="step-2-49z">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Billing Address">
                            Billing Address
                        </div>

                    </div>
                    <div className="form">

                        {inputField({
                            label: "Address Line",
                            path: "streetAddress",
                            inputProps: {
                                maxLength: 255,
                            },
                        })}

                        <div className="wrap-line">

                            {cs(
                                consumeContext("countryCodes"),
                                ({countryCodes}) => selectField({
                                    label: "Country",
                                    path: "country",

                                    getControl: (field) => ({
                                        list: Object.keys(countryCodes||{}),
                                        itemToLabel: (code) => countryCodes[code],
                                        isSelected: (code) => data.value?.["country"] === code,
                                        onChange: (countryCode) => {
                                            data.change((_) => ({
                                                ..._,
                                                country: countryCode,
                                                state: null,
                                            }))
                                        },

                                        autofill: {
                                            getItem: getCountryName2,
                                            name: "country",
                                            onChange: field.state.onChange,
                                        },
                                    }),
                                    xdQaName: "Country",
                                })
                            )}


                            {["US","CA"].includes(data.value?.["country"]) ? (
                                selectField({
                                    label: "State/Province/Region",
                                    path: "stateProvince",

                                    getControl: (field) => ({
                                        list: data.value?.country === "CA" ? canadaProvinces : usStates,
                                        itemToLabel: (r) => r.name,
                                        isSelected: (r) => field.state.value === r.abbreviation,
                                        onChange: (r) => field.state.onChange(r.abbreviation),

                                        autofill: {
                                            getItem: (str) => (
                                                usStates.find((s) => s.abbreviation === str) ??
                                                usStates.find((s) => s.name.toLowerCase() === str.toLowerCase())
                                            ),
                                            name: "state",
                                        },
                                    }),
                                    xdQaName: "State/Province/Region",
                                })
                            ) : (
                                inputField({
                                    label: "State/Province/Region",
                                    path: "stateProvince",
                                })
                            )}
                        </div>
                        <div className="wrap-line">

                            {inputField({
                                label: "City",
                                path: "city",
                                inputProps: {
                                    maxLength: 255,
                                },
                            })}
                            {inputField({
                                label: "Postal Code",
                                path: "zip",
                                inputProps: {
                                    maxLength: 9,
                                },
                            })}
                        </div>

                    </div>

                    {submitError.value && (
                        <div className="error">
                            {submitError.value.toString()}
                        </div>
                    )}

                </div>
            );
        },
    }),
);


export const formFields = [
    {
        path: ["streetAddress"],
        validators: [required],
    },
    {
        path: ["city"],
        validators: [required],
    },
    {
        path: ["stateProvince"],
        validators: [required],
    },
    {
        path: ["country"],
        validators: [required],
    },
    {
        path: ["zip"],
        validators: [required, minLength(4)],
    },
];